<template>
    <div class="invitationCode">
        <div v-if="!popShow">
            <van-popup
                v-model="show"
                closeable
                close-icon="close"
                position="bottom"
                :close-on-click-overlay='false'
            >
                <div class="content">
                    <div class="title">请先完善企业信息</div>
                    <div class="input">
                        <van-field
                            v-model="companyName"
                            type="text"
                            required
                            maxlength = '50'
                            label="企业简称"
                            placeholder="请输入您的企业名称或店铺名称"
                        />
                        <van-field
                            v-model="addressName"
                            type="text"
                            required
                            @click="onArea"
                            maxlength = '11'
                            label="经营区域"
                            :readonly = 'true'
                            right-icon="question-o"
                            placeholder="请选择您的经营区域"
                        />
                        <p>经营区域决定了您能看到商品的区域，请如实填写哦</p>
                        <van-field
                            v-model="code"
                            type="text"
                            required
                            label="邀请码"
                            placeholder="请输入商家邀请码"
                        />
                    </div>
                    <div class="btn">
                        <p @click="onSubmit"><van-button  color="#FF7A45" :round="true" type="default">确认创建</van-button></p>
                    </div>
                    <areaList ref="area" @onArea='onAreaData'></areaList>
                </div>
            </van-popup>
        </div>
        <div v-else>
            <div class="content">
                <div class="title">请先完善企业信息</div>
                <div class="input">
                    <van-field
                        v-model="companyName"
                        type="text"
                        required
                        maxlength = '50'
                        label="企业简称"
                        placeholder="请输入您的企业名称或店铺名称"
                    />
                    <van-field
                        v-model="addressName"
                        type="text"
                        required
                        @click="onArea"
                        maxlength = '11'
                        label="经营区域"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择您的经营区域"
                    />
                    <p>经营区域决定了您能看到商品的区域，请如实填写哦</p>
                    <van-field
                        v-model="code"
                        type="text"
                        required
                        label="邀请码"
                        placeholder="请输入商家邀请码"
                    />
                </div>
                <div class="btn">
                    <p @click="onSubmit"><van-button  color="#FF7A45" :round="true" type="default">确认创建</van-button></p>
                </div>
                <areaList ref="area" @onArea='onAreaData'></areaList>
            </div>
        </div>
    </div>
</template>
<script>
import areaList from '../common/area'
import { mapActions } from 'vuex'
import { Toast } from 'vant'
export default {
    name: 'invitationCode',
    components: {
        areaList
    },
    props: {
        popShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            companyName: '',
            addressName: '',
            code: '',
            areaData: '',
            show: false
        }
    },
    methods: {
        ...mapActions(['createCompany', 'getUserInfoData']),
        onArea () {
            this.$refs.area.onShow()
        },
        async onSubmit () {
            if (!this.companyName) {
                Toast('请输入企业简称')
                return false
            }
            if (!this.addressName) {
                Toast('请选择经营区域')
                return false
            }
            if (!this.code) {
                Toast('请输入商家邀请码')
                return false
            }
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            try {
                await this.createCompany({
                    companyName: this.companyName,
                    provinceId: this.areaData.provinceId,
                    provinceName: this.areaData.provinceName,
                    cityId: this.areaData.cityId,
                    cityName: this.areaData.cityName,
                    countryId: this.areaData.countryId,
                    countryName: this.areaData.countryName,
                    invitationCode: this.code,
                    createBy: this.userInfo.id
                }).then(async (data) => {
                    await this.getUserInfoData()
                    Toast({
                        message: '保存成功',
                        duration: 2000
                    })
                    setTimeout(() => {
                        this.$emit('submitCode')
                        this.show = false
                    }, 2000)
                })
            } catch (error) {
                // Toast.clear()
            }
        },
        onAreaData (data) {
            this.addressName = data.addressName
            this.areaData = data
        },
        init () {
            this.show = true
        }
    },
    mounted () {
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        this.code = this.userInfo.belongMerchantInviteCode
    }
}
</script>
<style lang="scss" scoped>
    .content{
        padding: 32px 0;
        .title{
            font-size: 34px;
            color: #333333;
            padding-left: 32px;
            margin-bottom: 40px
        }
        .input{
            background: #ffffff;
            padding-left: 32px;
            font-size: 28px;
            p{
                font-size: 26px;
                color: #FF7A45;
                margin-top: 16px;
            }
        }
        .btn{
            margin-top: 54px;
            padding: 0 32px;
        }
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
    /deep/ .van-popup__close-icon{
        font-size: 48px;
    }
    /deep/ .van-icon-question-o:before{
        content: "\F00A";
    }
    /deep/ .van-popup__close-icon--top-right{
        top: 32px;
    }
    /deep/ .van-cell__value{
        padding-right: 20px;
    }
    /deep/.van-cell::after{
        position: absolute;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 0.026667rem solid #cccccc;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
    }
</style>